
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../../../Components/Text.js";
import { ImageWidget } from "../../../Widgets/Image/ImageWidget.js";
import { defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Msg } from "./Types.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { Button } from "../../../Components/Button.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

function ProtocolConfiguration(props) {
    let elems_2, elems_1;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("general.image"),
    })), delay(() => {
        let ImageUrl, matchValue;
        return append(singleton(createElement(ImageWidget, (ImageUrl = defaultArg(props.ProtocolConfiguration.ImageUrl, ""), {
            CanEditImage: (matchValue = props.UserData.Role, (matchValue === "system") ? true : ((matchValue === "toolManager") ? true : (!(matchValue === "user")))),
            ImageUrl: ImageUrl,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(2, []));
            },
            OnUploadImage: (file) => {
                props.Dispatch(new Msg(1, [file]));
            },
        }))), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "",
            Text: t("settings.protocol.optional_fields_title"),
        })), delay(() => append(singleton(Checkbox({
            ComponentState: componentState,
            IsChecked: props.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds,
            Label: t("general.qr_code"),
            OnCheck: (value_3) => {
                props.Dispatch(new Msg(0, [value_3]));
            },
            TestId: "qr-code-ids-visible",
        })), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = FormState__getValidation(props.FormState, t, "global"), (matchValue_1 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                Label: matchValue_1,
            }))), delay(() => {
                let elems;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems = [createElement(Button, {
                    ComponentState: componentState,
                    Label: t("general.save"),
                    OnClick: () => {
                        props.Dispatch(new Msg(7, []));
                    },
                    TestId: "update-sso-configuration",
                    Variant: "primary",
                })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            }));
        }))))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ProtocolSettings(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProtocolConfiguration;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems = [createElement(ProtocolConfiguration, {
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
            ProtocolConfiguration: matchValue.fields[0],
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

